"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlphaHex = void 0;
const HexAlphaKeys_1 = require("../themes/HexAlphaKeys");
const getAlphaHex = (hex, percent) => {
    return hex + HexAlphaKeys_1.HexAlphaKeys[percent];
};
exports.getAlphaHex = getAlphaHex;
//# sourceMappingURL=ColorUtils.js.map